/* eslint-disable react/react-in-jsx-scope */
import { default as QMASDocumentModalCell } from './QmasDocumentCell';

const CellFactory = (type, props) => {
  switch (type) {
    case 'QMASDocumentModalCell':
      return <QMASDocumentModalCell {...props} />;
    default:
      return null;
  }
};

export default CellFactory;
// Compare this snippet from src/components/Molecules/Table/Cells/CellFactory.test.js:
